import React, { useCallback, useEffect, useState } from 'react';
import { Container, IconButton, Typography } from '@material-ui/core';
import { BannerPreview, Title } from './style';
import { DataGrid } from '@material-ui/data-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import AddBanner from '../Forms/AddBanner';
import TableHeader from '../common/TableHeader';
import { ModalAction } from '../common/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { createBanner, deleteBannerById, getBannerById, getBanners, updateBanner } from '../../actions/Banners';
import { Text } from '../common/NotificationTable/style';
import { Noresults } from '../../Layout/style';

const AdminBanner = () => {
  const dispatch = useDispatch();
  const { banners, bannerInfo, user } = useSelector(({ banners, auth }) => ({
    banners: banners?.banners || [],
    bannerInfo: banners?.bannerInfo || [],
    user: auth?.userData?.userLogado?.adm_login || null
  }));

  const [modal, setModal] = useState({
    open: false,
    type: null,
    title: null,
    action: null,
  });
  const [formData, setFormData] = useState({});
  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  let valideFormData = formData?.name && formData?.startDate && formData?.endDate && formData?.url && formData?.img;

  useEffect(() => {
    dispatch(getBanners());
  }, []);

  useEffect(() => {
    setFormData({ ...bannerInfo });
  }, [bannerInfo]);

  useEffect(() => {
    const searchRegex = new RegExp(searchString, 'gi');
    const searchedItens = banners.filter((i) => i.name.match(searchRegex));

    if (!searchRegex) setFilteredElements(banners);
    else setFilteredElements(searchedItens);
  }, [banners, searchString]);

  const closeAndUpdate = useCallback(() => {
    dispatch(getBanners());
    setModal({ open: false, type: null, title: null, action: null });
    setFormData({});
  });

  const handleAdd = useCallback(() => {
    dispatch(createBanner({ ...formData, userWhoCreated:user })).then(() => closeAndUpdate());
  });

  const handleEdit = useCallback(() => {
    let params = { id: bannerInfo.id, userWhoModified: user };

    if (formData.name && formData.name !== bannerInfo.name) params = { ...params, name: formData.name };
    if (formData.startDate && formData.startDate !== bannerInfo.startDate) params = { ...params, startDate: formData.startDate };
    if (formData.endDate && formData.endDate !== bannerInfo.endDate) params = { ...params, endDate: formData.endDate };
    if (formData.url && formData.url !== bannerInfo.url) params = { ...params, url: formData.url };
    if (formData.img && formData.img !== bannerInfo.img) params = { ...params, img: formData.img };

    dispatch(updateBanner(params)).then(() => closeAndUpdate());
  });

  const columns = [
    {
      field: 'position',
      width: 100,
      headerName: 'Posição',
      renderCell: ({ row }) => <Text>{row.position}</Text>,
    },
    {
      field: 'name',
      width: 200,
      headerName: 'Nome da Campanha',
      renderCell: ({ row }) => <Text>{row.name}</Text>,
    },
    {
      field: 'img',
      renderCell: ({ row }) => row.img && <BannerPreview src={row.img} />,
      sortable: false,
      width: 540,
      headerName: 'Banner Preview',
    },
    {
      field: 'startDate',
      sortable: false,
      width: 120,
      headerName: 'Início',
      renderCell: ({ row }) => <Text>{row.startDate}</Text>,
    },
    {
      field: 'endDate',
      sortable: false,
      width: 120,
      headerName: 'Fim',
      renderCell: ({ row }) => <Text>{row.endDate}</Text>,
    },
    {
      field: 'actions',
      headerName: 'Açoes',
      width: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <IconButton
            onClick={() => {
              dispatch(getBannerById(row.id)).then(() =>
                setModal({
                  open: true,
                  type: 'edit',
                  title: 'Editar Banner',
                }),
              );
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </IconButton>
          <IconButton
            onClick={() =>
              setModal({
                open: true,
                type: 'del',
                title: 'Deletar Banner',
                action: () => {
                  dispatch(deleteBannerById(row.id)).then(() => closeAndUpdate());
                },
              })
            }
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <Container>
        <Title variant="h2">Gestão de Banners</Title>
        <TableHeader
          setSearchString={setSearchString}
          placeholder="Pesquisar por Nome"
          btnAction={() =>
            setModal({
              open: true,
              type: 'add',
              title: 'Adicionar Banner',
              action: () => handleAdd(),
            })
          }
        />
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
           components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            loading={filteredElements ? false : true}
            rows={filteredElements.length ? filteredElements : []}
            columns={columns}
          />
        </div>
      </Container>
      <ModalAction
        title={modal.title || 'Modal'}
        successAction={modal.type === 'add' ? () => handleAdd() : modal.type === 'edit' ? () => handleEdit() : modal.action}
        successLabel={modal.type === 'add' || modal.type === 'edit' ? 'Salvar' : 'Deletar'}
        open={modal.open}
        successActive={modal.type === 'add' || modal.type === 'edit' ? (valideFormData ? true : false) : true}
        backAction={() => {
          setModal({ open: false, type: null });
          setFormData({});
        }}
      >
        {modal.type === 'add' && <AddBanner formData={formData} setFormData={setFormData} />}
        {modal.type === 'edit' && <AddBanner formData={formData} setFormData={setFormData} />}
        {modal.type === 'del' && <Typography>Tem certeza que deseja deletar o Banner?</Typography>}
      </ModalAction>
    </>
  );
};

export default AdminBanner;
